import LeaderProfile from './Leader_Profile/LeaderProfile.jsx';
import { principal } from './Leader_Profile/LeaderProfile.js';


const Principal = () => {
    return (
        <LeaderProfile
            name={principal.name}
            education={principal.education}
            majorActivities={principal.majorActivities}
            collegeIntro={principal.collegeIntro}
            image={principal.image}
            designation={principal.designation}
        />
    )
}

export default Principal
